// extracted by mini-css-extract-plugin
export default {"section":"ExpandableSection_section__os5Om"};